export default __webpack_public_path__ + "static/media/TMU-mono.648663e6.svg";